import React from "react";

export default function DocButtomButton({ name, func, loading }) {
  return (
    <div className="text-center mb-10 mt-10">
      <button
        type="submit"
        className="a_acc_btn"
        onClick={() => func()}
        disabled={loading ? true : false}
      >
        {loading ? <i className="fa fa-spinner fa-spin icon_class mr-1" /> : ""}
        {name}
      </button>
    </div>
  );
}
